import { render, staticRenderFns } from "./JobworkerForm.vue?vue&type=template&id=1ab5ab84&scoped=true"
import script from "./JobworkerForm.vue?vue&type=script&lang=js"
export * from "./JobworkerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab5ab84",
  null
  
)

export default component.exports